import React from 'react';
import * as _ from 'lodash';

export const withNumbers = state => WrappedComponent => {
  class _InputForm extends React.Component {
    constructor(props) {
      super(props);

      const _state = state();
      let type = _.filter(_state.keys, item => {
        return item.key === props.keyName;
      });

      this.state = {
        value: null,
        keys: _state.keys,
        type: type[0],
      };
      this.codeValue = props.codeValue;
    }

    componentDidMount() {
      this.codeValue.subscribe(() => {
        const value = this.codeValue.get(this.state.type.key);
        this.setState({ value });
      });
    }

    componentDidUpdate(prevProps) {
      if (this.props.value !== prevProps.value) {
        this.codeValue.setAll(this.props.value);
      }
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          value={this.state.value}
          onUpdate={(value, params, target) => {
            this.codeValue.set(this.state.type.key, value);
            if (this.props.onUpdate) {
              const numbers = this.codeValue.getAll();
              this.props.onUpdate(numbers, params, target);
            }
          }}
          onValidationCheck={() => {
            const numbers = this.codeValue.getAll();
            this.props.onValidationCheck(numbers);
          }}
        />
      );
    }
  }
  _InputForm.displayName = `_InputForm(${getDisplayName(WrappedComponent)})`;
  return _InputForm;
};

const getDisplayName = WrappedComponent => {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};



// WEBPACK FOOTER //
// ./src/hocs/withNumbers.jsx